import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	Button,
	FullBar,
	Label,
	Dropdown,
} from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";

export const BrandFontGoogle = (props) => {
	//TODO google font, custom font, regular typo
	useEffect(() => {}, []);
	return (
		<div className="brandElement-fonts">
			<Dropdown
				type="custom"
				shapeSytle="outline"
				placeholder={I18n.t("app-brand-fonts-typography-DD-placeholder")}
				options={[{ label: "Font 1", value: "font1", selected: true }]}
			/>
		</div>
	);
};

BrandFontGoogle.propTypes = {};

BrandFontGoogle.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(BrandFontGoogle)
);
